import { createDevextremeDatasource } from '@/letapps-vue/utils/useRestApi';

let store;

export function getLinkDatasource() {
  if (!store) {
    store = createDevextremeDatasource('/api/Links', 'id', {
      paginate: false,
    });
  }

  return store;
}
